import RankingStat from '../../entities/RankingStat.js';
import PitchingRankingStats from '../../enums/PitchingRankingStats.js';
import NumberFormatter from '../../formatters/NumberFormatter.js';
import SelectiveRankingStatCalculatorBase from './SelectiveRankingStatCalculatorBase.js';

class StrikeoutMinusWalkPercentageStatCalculator extends SelectiveRankingStatCalculatorBase {
    constructor(numberFormatter) {
        if (typeof(numberFormatter) !== 'undefined' && !(numberFormatter instanceof NumberFormatter)) {
            throw new TypeError('numberFormatter must be an instance inheriting from NumberFormatter class');
        }
        super([
            PitchingRankingStats.StrikeoutMinusWalkPercentage
        ]);

        this.dependencies = [PitchingRankingStats.StrikeoutRate, PitchingRankingStats.WalkRateAllowed];
        this.numberFormatter = numberFormatter || new NumberFormatter(3);
    }

    listDependencies(parameter) {
        // TODO - maybe concat ?
        return this.dependencies;
    }

    calculateStat(parameter, dependencies) {
        const strikeoutsRate = dependencies[0];
        const walksRate = dependencies[1];
        if (
            !(strikeoutsRate || strikeoutsRate.isEmpty())
            && (!walksRate || walksRate.isEmpty())
        ) {
            return null;
        }

        const strikeoutsValue = (!strikeoutsRate || strikeoutsRate.isEmpty()) ? 0 : strikeoutsRate.value;
        const walksValue = (!walksRate || walksRate.isEmpty()) ? 0 : walksRate.value;
        const strikeoutsWeight = (!strikeoutsRate || strikeoutsRate.isEmpty()) ? 0 : strikeoutsRate.weight;
        const walksWeight = (!walksRate || walksRate.isEmpty()) ? 0 : walksRate.weight;

        // TODO - weight should be the same for both, otherwise we will need to calculate it with common denominator
        return RankingStat.fromParameter(
            parameter, this.numberFormatter.format(
                strikeoutsValue - walksValue
            ), strikeoutsWeight + walksWeight
        );
    }
}

export default StrikeoutMinusWalkPercentageStatCalculator;